import React from "react";
import NHFetch from "../../../../utils/NHFetch";
import JxZzbdtjcx from "../jxZzbdtjcx";//基线
import NhgsZzbdtjcx from "../nhgsZzbdtjcx";//广东南华工商

const baseUrlPath = "/swbl/lstd"; //基础路径
/**
 * 通用自助报到环节办理统计
 * @author yangqizhi
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["zzbdhjbltj"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "gdnhgs") {
                          return <NhgsZzbdtjcx/>
                      } else {
                          return <JxZzbdtjcx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxZzbdtjcx/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/zzbdtjcx/tyZzbdtjcx/index.js